exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3dP6J_8qiKRgDspqoOUH2C{max-width:800px}html[dir] ._3dP6J_8qiKRgDspqoOUH2C{padding:6px 10px 8px 10px;background-color:\"[theme:neutralLighterAlt, default:#f8f8f8]\"}", ""]);
// Exports
exports.locals = {
	"paneWrapper": "_3dP6J_8qiKRgDspqoOUH2C"
};